import { QUERY_PARAMS } from '../searchFlyoutConfig';

export const orderedSearchQuery = (searchQuery: Record<string, string>): Record<string, any> =>
  QUERY_PARAMS.reduce((obj: Record<string, any>, key) => {
    if (searchQuery.hasOwnProperty(key)) {
      obj[key] = searchQuery[key];
    }
    return obj;
  }, {});
